import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { ISOToDisplayCode } from "@utils";
import { THEME_SETTINGS } from "@theme-settings";

export default observer(function CashoutButtonCore() {
	const { displayedAmount } = useContext(MyBetsBetContext);
	const { t } = useTranslation("mybets");

	return (
		<>
			{t("CASHOUT.TITLE")} {displayedAmount}{" "}
			{ISOToDisplayCode(THEME_SETTINGS.defaultCurrency)}
		</>
	);
});
